export default __webpack_public_path__ + "static/pronex-44e03fb895f5a25e6a3200b070f4d6da.png";